// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface CustomSubmitContactUsFormApiParameter extends ApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    zipCode?: string;
    shipToLocationName?: string;
    physicalAddress?: string;
    customerId?: string;
    defaultBranch?: string;
    pickupBranch?: string;
    deliveryLocation?: string;
}

export async function submitContactUsForm(data: CustomSubmitContactUsFormApiParameter): Promise<ServiceResult<void>> {
    try {
        const result = await post<CustomSubmitContactUsFormApiParameter, void>("/api/cmi/ContactUsCustom", data);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400) {
            return {
                successful: false,
                errorMessage: error as string,
            };
        }
        return {
            successful: false,
            errorMessage: error as string,
        };
    }
}
